import React, { useCallback } from 'react';
import { Dialog } from 'components/Dialog/Dialog';
import { useConfirmModalStore } from '../../stores/confirmModalStore';

export const ConfirmModal = () => {
  const { isOpen, heading, description, closeLabel, okLabel, onOk, onClose, closeConfirmModal } =
    useConfirmModalStore();

  const onCloseDialog = useCallback(
    (e) => {
      if (onClose) {
        onClose(e);
      }
      closeConfirmModal();
    },
    [onClose, closeConfirmModal],
  );

  const handleOk = useCallback(
    (e) => {
      if (onOk) {
        onOk(e);
      }
    },
    [onOk],
  );

  if (!isOpen) return null;

  return (
    <Dialog
      buttonsProps={[
        {
          label: okLabel,
          onClick: handleOk,
        },
      ]}
      closeLabel={closeLabel}
      description={description}
      heading={heading}
      setCloseDialog={onCloseDialog}
    />
  );
};
